import { createContext } from 'react'

// export interface LunwenState {
//   [key: string]?: number
// }
export type LunwenState = Record<string, any>
export interface LunwenAction {
  type: 'SET_LUNWEN_DATA'
  payload: any
}

export const LunwenContext = createContext<LunwenState | null>(null)

export const initLunwenState: LunwenState = {}

export const lunwenReducer = (state: LunwenState, action: LunwenAction): LunwenState => {
  switch (action.type) {
    case 'SET_LUNWEN_DATA':
      return { ...state, ...action.payload }
    default:
      return state
  }
}
